/**
 * MoonTexture courtesy of NASA: https://svs.gsfc.nasa.gov/4720
 * @author Damian Browne
 */
import { Group, Mesh, SphereGeometry, MeshPhongMaterial, TextureLoader } from 'three'
import MoonTexture from '../textures/moon_color.png'

class Moon {
  constructor() {
    const loader = new TextureLoader()
    const texture = loader.load(MoonTexture)
    const geometry = new SphereGeometry(1, 8, 8)
    const material = new MeshPhongMaterial({ map: texture })
    const mesh = new Mesh(geometry, material)

    this.group = new Group()
    this.group.add(mesh)
    this.type = 'planet'
  }

  move(position) {
    this.group.position.x -= 0.1
    this.group.rotation.y += 0.001
  }
}

export default Moon
